import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/code/loginQuestion',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-LoginQuestion" */ '~/pages/r_code/LoginQuestion'
        )
    ),
  },
  {
    path: '/code/loginQuestion/LoginQs',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-LoginQuestion-LoginQs" */ '~/pages/r_code/LoginQuestion/LoginQs'
        )
    ),
  },
] as RouteConfig[]
